var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.859497 5.15C0.602138 5.27105 0.384541 5.46284 0.232127 5.70295C0.079714 5.94307 -0.0012207 6.2216 -0.0012207 6.50601C-0.0012207 6.79041 0.079714 7.06894 0.232127 7.30906C0.384541 7.54917 0.602138 7.74096 0.859497 7.86201L3.0045 8.87451V14.7545C3.0045 15.8675 3.366 17.1095 4.4205 17.8745C5.7495 18.8345 8.1705 20.0045 12.0105 20.0045C15.8505 20.0045 18.2655 18.827 19.6005 17.8745C20.655 17.1125 21.0165 15.8795 21.0165 14.7545V8.87451L22.5165 8.165V14.75C22.5165 14.9489 22.5955 15.1397 22.7362 15.2803C22.8768 15.421 23.0676 15.5 23.2665 15.5C23.4654 15.5 23.6562 15.421 23.7968 15.2803C23.9375 15.1397 24.0165 14.9489 24.0165 14.75V6.5C24.0166 6.21593 23.936 5.93768 23.7841 5.69763C23.6322 5.45758 23.4152 5.26559 23.1585 5.14401L14.5785 1.094C13.7766 0.714787 12.9006 0.518097 12.0135 0.518097C11.1264 0.518097 10.2504 0.714787 9.4485 1.094L0.868497 5.14401L0.859497 5.15ZM4.5045 14.75V9.57501L9.4395 11.915C10.2414 12.2942 11.1174 12.4909 12.0045 12.4909C12.8916 12.4909 13.7676 12.2942 14.5695 11.915L19.5045 9.57501V14.75C19.5045 15.584 19.2345 16.265 18.7095 16.64C17.6235 17.4245 15.5145 18.5 12.0045 18.5C8.4945 18.5 6.3795 17.432 5.2995 16.64C4.776 16.262 4.5045 15.5765 4.5045 14.75ZM10.0845 2.45C10.6846 2.16572 11.3404 2.01825 12.0045 2.01825C12.6686 2.01825 13.3244 2.16572 13.9245 2.45L22.5045 6.5L13.9245 10.55C13.3244 10.8343 12.6686 10.9818 12.0045 10.9818C11.3404 10.9818 10.6846 10.8343 10.0845 10.55L1.5045 6.5L10.0845 2.45Z",
    fill: "url(#paint0_linear_773_430)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_430",
    x1: -0.0012207,
    y1: 10.2613,
    x2: 24.0165,
    y2: 10.2613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0B3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#107650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.90ebce0e95e68b8a91104d7238f7f6e9.svg";
export { ForwardRef as ReactComponent };